import {AbstractModel} from "./abstract-model";
import {UploadFile} from './upload-file';

export class ComplianceUploadFile extends AbstractModel {

  id: number | null = null;
  status: string = 'pending';
  expireAtDate: string | null = null;
  document: UploadFile = new UploadFile();

  isEmpty(): boolean {
    return !this.id && this.document.isEmpty();
  }

  getData(type: string): any {
    const data: any = {
      type,
      status: this.status,
      expireAt: this.expireAtDate ? new Date(this.expireAtDate) : null,
    };

    if (!this.document.isEmpty()) {
      data.document = this.document;
    }

    return data;
  }
}
